module.exports = __webpack_public_path__ + "static/media/home_1.1a2dc40e.jpg";